var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"show-hide",on:{"click":_vm.onClick}},[_c('i',{class:['af-icons', 'af-icons-' + (_vm.isVisible ? 'read-off' : 'preview')]}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }